import type { JSX } from 'react'

import { NavBar as ArcanaNavBar, NavBarLogo as ArcanaNavBarLogo } from "/app/libraries/arcana/src/containers/NavBar/index.ts"
import { BrandContainerDefault } from "/app/libraries/arcana/src/blocks/BrandContainer/Templates/index.ts"
import { Link } from "/app/libraries/arcana/src/atoms/Link/index.ts"
import { NavTab } from "/app/libraries/arcana/src/atoms/NavTab/index.ts"
import { SecondarySearchButton } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useCallback, useState } from 'react'
import { model as router } from '~/core/router'
import { profilesModel } from '~/entities/profiles'
import { model as session } from '~/entities/session'
import { model as logoModel } from '~/features/logo'
import { model as guestModel } from '~/features/subscriber/guest'
import { aye } from '~/shared/helpers'
import { PROFILES, SEARCH } from '~/shared/routes'
import { NavBarDropdown } from './components/NavBarDropdown'
import { NavBarModules } from './components/NavBarModules'
import { $modules, $signInHref } from './model'
import { $navbarDropDownTitles } from './translations'

NavBar.displayName = 'NavBar'

export function NavBar(): JSX.Element | null {
  const [mobileMenuResetKey, setMobileMenuResetKey] = useState(0)
  const isAuthenticated = useUnit(session.$authenticated)
  const activeProfile = useUnit(profilesModel.$activeProfile)
  const guest = useUnit(guestModel.$guest)
  const pathname = useUnit(router.$pathname)
  const logoUrl = useUnit(logoModel.$logoUrl)
  const signInHref = useUnit($signInHref)
  const navbarDropDownTitles = useUnit($navbarDropDownTitles)
  const modules = useUnit($modules)

  const isNavbarShown =
    isAuthenticated &&
    (aye(activeProfile) || aye(guest)) &&
    !pathname?.includes(PROFILES.CHOOSE) &&
    !pathname?.includes(PROFILES.CREATE)

  const href = useUnit(router.$href) ?? ''
  const resetCheckedKey = `${href}:${mobileMenuResetKey}`

  const isEmpty = !modules || modules.length === 0
  const handleMobileMenuReset = useCallback(() => {
    setMobileMenuResetKey((key) => key + 1)
  }, [])

  // When navbar is hidden: show only logo
  if (!isNavbarShown) {
    return (
      <ArcanaNavBarLogo>
        <BrandContainerDefault logoUrl={logoUrl} />
      </ArcanaNavBarLogo>
    )
  }

  // Full navbar
  return (
    <ArcanaNavBar isEmpty={isEmpty} resetCheckedKey={resetCheckedKey}>
      <Link href='/'>
        <BrandContainerDefault logoUrl={logoUrl} />
      </Link>

      <NavBarModules onInteract={handleMobileMenuReset} />

      <Link href={SEARCH.ROOT} onClickCapture={handleMobileMenuReset}>
        <SecondarySearchButton />
      </Link>

      {guest ? (
        <Link href={signInHref} onClickCapture={handleMobileMenuReset}>
          <NavTab title={navbarDropDownTitles.signIn} />
        </Link>
      ) : (
        <NavBarDropdown onInteract={handleMobileMenuReset} />
      )}
    </ArcanaNavBar>
  )
}
